import { initDB } from './dbService';

const NOTES_STORE = 'notes';
const NOTES_ID = 'main-notes'; // ID unique pour les notes principales

/**
 * Charger les notes depuis IndexedDB
 */
export async function loadNotes() {
  try {
    const db = await initDB();
    const transaction = db.transaction([NOTES_STORE], 'readonly');
    const store = transaction.objectStore(NOTES_STORE);

    return new Promise((resolve, reject) => {
      const request = store.get(NOTES_ID);

      request.onsuccess = () => {
        const result = request.result;
        resolve(result ? result.content : '');
      };

      request.onerror = () => {
        console.error('Erreur lors du chargement des notes:', request.error);
        reject(request.error);
      };
    });
  } catch (error) {
    console.error('Erreur lors du chargement des notes:', error);
    return '';
  }
}

/**
 * Sauvegarder les notes dans IndexedDB
 */
export async function saveNotes(content) {
  try {
    const db = await initDB();
    const transaction = db.transaction([NOTES_STORE], 'readwrite');
    const store = transaction.objectStore(NOTES_STORE);

    const notesData = {
      id: NOTES_ID,
      content: content,
      lastModified: new Date().toISOString()
    };

    return new Promise((resolve, reject) => {
      const request = store.put(notesData);

      request.onsuccess = () => {
        resolve(notesData);
      };

      request.onerror = () => {
        console.error('Erreur lors de la sauvegarde des notes:', request.error);
        reject(request.error);
      };
    });
  } catch (error) {
    console.error('Erreur lors de la sauvegarde des notes:', error);
    throw error;
  }
}

/**
 * Effacer toutes les notes
 */
export async function clearNotes() {
  try {
    const db = await initDB();
    const transaction = db.transaction([NOTES_STORE], 'readwrite');
    const store = transaction.objectStore(NOTES_STORE);

    return new Promise((resolve, reject) => {
      const request = store.delete(NOTES_ID);

      request.onsuccess = () => {
        console.log('✅ Notes effacées');
        resolve();
      };

      request.onerror = () => {
        console.error('Erreur lors de l\'effacement des notes:', request.error);
        reject(request.error);
      };
    });
  } catch (error) {
    console.error('Erreur lors de l\'effacement des notes:', error);
    throw error;
  }
}